import SwitchSymphony, { SwitchType } from "elements/SwitchSymphony";
import { makeKey } from "modules/Utils";
import TagSymphony, { TagColors } from "elements/TagSymphony";
import { CAMPAIGN_STATUS_INFO, CampaignStatus } from "modules/Const";

interface CampaignFilterListItemsProps {
    title: string;
    listItems: {
        key: string;
        onClick: (key: string) => void;
        icon?: string;
        checked: boolean;
        label: string;
    }[];
}

const CampaignFilterListItems = ({
    title = "Campaign Types",
    listItems = [],
}: CampaignFilterListItemsProps) => {
    return (
        <div
            className="campaignFilterListItems"
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
                maxWidth: 340,
            }}
        >
            <div className="campaignFilterListItemsTitle">
                {title}
            </div>
            <div
                className="campaignFilterListItemsList"
                style={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
                {listItems.map((item, index) => {
                    const {
                        key,
                        onClick,
                        icon,
                        checked,
                        label
                    } = item;

                    return (
                        <div
                            key={makeKey(key, index)}
                            className="campaignFilterListItemsItem"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "4px 0",
                                cursor: "pointer",
                            }}
                            onClick={() => onClick(key)}
                        >
                            <SwitchSymphony
                                className="campaignFilterListItemsSwitch"
                                checked={checked}
                                type={SwitchType.CHECKBOX}
                                style={{
                                    marginRight: 8,
                                }}
                            />
                            {icon ?
                                <TagSymphony
                                    className="campaignFilterListItemsTag1"
                                    title={label}
                                    icon={icon}
                                    type="square"
                                />
                                :
                                <TagSymphony
                                    className="campaignFilterListItemsTag2"
                                    title={label.toUpperCase()}
                                    color={(CAMPAIGN_STATUS_INFO[key.toUpperCase() as CampaignStatus]?.color) as TagColors}
                                    type="square"
                                />
                            }
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default CampaignFilterListItems